var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('App',[_c('div',{staticClass:"layout"},[_c('Sidebar',{attrs:{"links":_vm.sideNavRoutes}}),_vm._v(" "),_c('main',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }